module.exports = __webpack_public_path__ + "static/media/presentation.0e7d5974.svg";